import { render, staticRenderFns } from "./goodsItem1.vue?vue&type=template&id=63b96262&scoped=true&"
import script from "./goodsItem1.vue?vue&type=script&lang=js&"
export * from "./goodsItem1.vue?vue&type=script&lang=js&"
import style0 from "./goodsItem1.vue?vue&type=style&index=0&id=63b96262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b96262",
  null
  
)

export default component.exports